<script lang="ts">

  import "./layout.css"
  import { ViewerDoc, ViewerHelp, ViewerImage, ViewerLog, ViewerPdf } from "$lib/components"
  import { Toaster } from "$lib/components/ui/sonner"
  import { APP_NAME } from "$lib/env"
  import { QueryClient, QueryClientProvider } from "@tanstack/svelte-query"
  import { onMount } from "svelte"
  import { RenderScan } from "svelte-render-scan"
  import AppProvider from "./_components/app-provider.svelte"
  import DeviceProvider from "./_components/device-provider.svelte"
  import ErrorBoundary from "./_components/error-boundary.svelte"

  import "$lib/env"
  import "$lib/global"
  import "$lib/axios-client"

  let { children } = $props()

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        networkMode: "always",
        refetchOnWindowFocus: false,
        retry: false,
        staleTime: 0,
        gcTime: 0,
      }
    }
  })

  onMount(() => {

    document.getElementById("splash")?.remove()

  })

</script>

<svelte:head>
  <title>{APP_NAME}</title>
</svelte:head>

{#if (import.meta.env.DEV && false)}
  <RenderScan offsetLeft={-40}/>
{/if}

<Toaster
  richColors
  position="top-center"
  theme="light"
/>
<ErrorBoundary>
  <QueryClientProvider client={queryClient}>
    <DeviceProvider>
      <AppProvider>
        {@render children()}
      </AppProvider>
    </DeviceProvider>
    <ViewerHelp/>
    <ViewerLog/>
    <ViewerPdf/>
    <ViewerDoc/>
    <ViewerImage/>
  </QueryClientProvider>
</ErrorBoundary>
